import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthenticationService, MgUser } from '../../../core/services/auth.service';

@Component({
  selector: 'mg-account-dropdown',
  standalone: true,
  templateUrl: './account-dropdown.component.html',
  styleUrls: ['./account-dropdown.component.scss'],
  imports: [CommonModule, RouterModule, NgbDropdownModule, TranslateModule]
})
export class AccountDropdownComponent implements OnInit {
  @Input() light = false;
  acc: MgUser | null = null;

  constructor(
    private authService: AuthenticationService,
    private translate: TranslateService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.authService.currentUser
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((acc) => {
        this.acc = acc;
      });

    this.authService.identity()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  get displayRole(): string {
    if (!this.acc) {
      return '';
    }
    // Root Super Admin always displays platform title (سوبر أدمن / Super Admin)
    if (this.acc.is_root) {
      return this.translate.instant('SUPER_ADMIN.TITLE');
    }
    // If staff has assigned platform role data
    if (this.acc.role) {
      const isAr = (this.translate.currentLang || 'ar') === 'ar';
      const roleName = isAr
        ? (this.acc.role.name_ar || this.acc.role.name)
        : (this.acc.role.name_en || this.acc.role.name);
      if (roleName) {
        return roleName;
      }
    }
    // If staff has a valid custom display_role that is not legacy Parent
    if (this.acc.display_role && this.acc.display_role !== 'Parent' && this.acc.display_role !== 'والد / ولي أمر') {
      return this.acc.display_role;
    }
    // Platform super_admin fallback
    if (this.acc.platform_role === 'super_admin') {
      return this.translate.instant('SUPER_ADMIN.TITLE');
    }
    // General fallback
    return this.acc.user_type?.name
      ? this.translate.instant(this.acc.user_type.name)
      : this.translate.instant('SUPER_ADMIN.TITLE');
  }

  logout(): void {
    this.authService.logout();
  }
}

